import React from 'react'

interface EntryToolbarProps {
    textareaRef: React.RefObject<HTMLTextAreaElement>
    value: string
    onChange: (newValue: string) => void
}

import { MediaUploadButton } from '../Common/MediaUploadButton'

export function EntryToolbar({ textareaRef, value, onChange }: EntryToolbarProps) {
    const applyFormat = (type: '(bkz:)' | 'hede' | '*' | '- spoiler -' | 'http://' | string, extra?: string) => {
        if (!textareaRef.current) return

        const textarea = textareaRef.current
        const start = textarea.selectionStart
        const end = textarea.selectionEnd
        const selectedText = value.substring(start, end)

        let replacement = ''
        let cursorOffset = 0

        if (type === 'image') {
            replacement = ` ${extra} ` // Insert raw URL with spaces for safety
            cursorOffset = replacement.length
        } else {
            switch (type) {
                case '(bkz:)':
                    replacement = `(bkz: ${selectedText})`
                    cursorOffset = selectedText ? 0 : 6 // Between space and )
                    break
                case 'hede':
                    replacement = `(hede: ${selectedText})`
                    cursorOffset = selectedText ? 0 : 7 // Between space and )
                    break
                case '*':
                    replacement = `*${selectedText}*`
                    cursorOffset = selectedText ? 0 : 1
                    break
                case '- spoiler -':
                    replacement = `--- spoiler ---\n${selectedText}\n--- spoiler ---`
                    cursorOffset = selectedText ? 0 : 16 // Inside the block
                    break
                case 'http://':
                    replacement = `(link: ${selectedText})`
                    cursorOffset = selectedText ? 0 : 7 // Between space and )
                    break
            }
        }

        const newValue = value.substring(0, start) + replacement + value.substring(end)
        onChange(newValue)

        // Focus back and set cursor
        setTimeout(() => {
            textarea.focus()
            const newCursorPos = start + (selectedText && type !== 'image' ? replacement.length : cursorOffset)
            textarea.setSelectionRange(newCursorPos, newCursorPos)
        }, 0)
    }

    const tools = [
        { label: '(bkz:)', type: '(bkz:)' as const },
        { label: 'hede', type: 'hede' as const },
        { label: '*', type: '*' as const },
        { label: '- spoiler -', type: '- spoiler -' as const },
        { label: 'http://', type: 'http://' as const },
    ]

    return (
        <div className="flex flex-wrap items-center gap-1">
            {tools.map((tool) => (
                <button
                    key={tool.label}
                    type="button"
                    onClick={() => applyFormat(tool.type)}
                    className="px-2 py-1 bg-surface-100 dark:bg-surface-800 hover:bg-surface-200 dark:hover:bg-surface-700 rounded text-[10px] font-mono text-gray-500 dark:text-gray-400 transition-colors border border-surface-200 dark:border-surface-700"
                >
                    {tool.label}
                </button>
            ))}

            <div className="w-px h-4 bg-surface-300 dark:bg-surface-700 mx-1" />

            <MediaUploadButton
                onUploadComplete={(url) => applyFormat('image', url)}
                className="px-2 py-1 bg-surface-100 dark:bg-surface-800 hover:bg-surface-200 dark:hover:bg-surface-700 rounded text-[10px] font-mono text-gray-500 dark:text-gray-400 transition-colors border border-surface-200 dark:border-surface-700 flex items-center gap-1.5"
            />
        </div>
    )
}
